import {
  AgentGroup,
  AgentGroupBatchPatchDto,
  AgentGroupPatchDto,
  CreateAgentGroupForm
} from "@closerplatform/spinner-openapi";
import { validateNoWhitespace, validateRequired } from "@fidget/common/utils/validatorsFormState";
import { FieldState, FormState } from "formstate";
import {
  ExistingAgentGroupFields,
  ExistingAgentGroupForm,
  NewAgentGroupFields,
  NewAgentGroupForm
} from "./types";

const nameValidators = () => [validateRequired, validateNoWhitespace];

export const mapAgentGroupToForm = (group: AgentGroup): ExistingAgentGroupForm => {
  return new FormState<ExistingAgentGroupFields>({
    id: new FieldState(group.id),
    name: new FieldState(group.name).validators(validateRequired),
    adviserIds: new FieldState(group.advisers),
    tagIds: new FieldState(group.tags),
    tagGroupIds: new FieldState(group.tagGroups)
  });
};
export const mapFormToAgentGroup = (form: ExistingAgentGroupForm, orgId: string): AgentGroup => {
  return {
    id: form.$.id.$,
    orgId,
    name: form.$.name.$,
    tags: form.$.tagIds.$,
    tagGroups: form.$.tagGroupIds.$,
    advisers: form.$.adviserIds.$
  };
};

export const createNewAgentGroupForm = (): NewAgentGroupForm => {
  const newForm = new FormState<NewAgentGroupFields>({
    name: new FieldState<string>("").validators(validateRequired),
    advisers: new FieldState<string[]>([])
  });
  newForm.$.name.validators(...nameValidators());

  return newForm;
};

export const copyExistingAgentGroupForm = (
  form: ExistingAgentGroupForm
): ExistingAgentGroupForm => {
  const updatedForm = new FormState<ExistingAgentGroupFields>({
    id: form.$.id,
    tagIds: new FieldState(form.$.tagIds.$),
    tagGroupIds: new FieldState(form.$.tagGroupIds.$),
    adviserIds: new FieldState(form.$.adviserIds.$),
    name: new FieldState(form.$.name.$)
  });

  updatedForm.$.name.validators(...nameValidators());

  return updatedForm;
};

export const mapNewFormToCreateForm = (form: NewAgentGroupForm): CreateAgentGroupForm => {
  return {
    name: form.$.name.$,
    advisers: form.$.advisers.$
  };
};

export const mapExistingFormToPatchForm = (form: ExistingAgentGroupForm): AgentGroupPatchDto => {
  return {
    tags: form.$.tagIds.$,
    tagGroups: form.$.tagGroupIds.$,
    advisers: form.$.adviserIds.$,
    name: form.$.name.$
  };
};

export const mapExistingFormsToPatchForms = (
  forms: ExistingAgentGroupForm[]
): AgentGroupBatchPatchDto[] => {
  return forms.map((f) => {
    return {
      id: f.$.id.$,
      name: f.$.name.$,
      tagGroups: f.$.tagGroupIds.$,
      tags: f.$.tagIds.$,
      advisers: f.$.adviserIds.$
    };
  });
};
